import { useCallback, useEffect, useState } from "react";
import { useModalFormStore } from "@/pages/profile/store/modal-form-store";

function rand() {
  var str = "abcdefghijklmnopqrstuvwxyz0123456789";
  var arr = str.split("");
  var validate = "";
  var ranNum;
  for (var i = 0; i < 4; i++) {
    ranNum = Math.floor(Math.random() * 36);
    validate += arr[ranNum];
  }
  return validate;
}
function lineX() {
  const ranLineX = Math.floor(Math.random() * 90);
  return ranLineX;
}

function lineY() {
  const ranLineY = Math.floor(Math.random() * 40);
  return ranLineY;
}
function getRandomColor() {
  return (
    "rgb(" +
    Math.round(Math.random() * 180) +
    "," +
    Math.round(Math.random() * 180) +
    "," +
    Math.round(Math.random() * 10) +
    ")"
  );
}

export function useVerifyCode(canvasId: string) {
  const [canvas, setCanvas] = useState<HTMLCanvasElement>();
  const [verifyCode, setVerifyCode] = useState("");
  const { openStudentCertifyDrawer } = useModalFormStore();

  const draw = useCallback(() => {
    const _canvas = canvas;
    if (!_canvas || !_canvas.getContext) return;
    const ctx = _canvas.getContext("2d");
    if (!ctx) return;
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, 90, 40);
    for (var j = 0; j < 5; j++) {
      ctx.strokeStyle = getRandomColor();
      ctx.beginPath();
      ctx.moveTo(lineX(), lineY());
      ctx.lineTo(lineX(), lineY());
      ctx.lineWidth = 0.5;
      ctx.closePath();
      ctx.stroke();
    }
    const verifyCode = rand();
    setVerifyCode(verifyCode);
    ctx.font = "bold 20px Arial";
    for (let i = 0; i < verifyCode.length; i++) {
      ctx.fillStyle = getRandomColor();
      ctx.fillText(verifyCode[i], 10 + 16 * i, 25);
    }
  }, [canvas]);

  useEffect(() => {
    const initCanvas = document.getElementById(canvasId) as HTMLCanvasElement;
    if (!initCanvas) return;
    initCanvas.addEventListener("click", draw);
    setCanvas(initCanvas);
    draw();
    return () => {
      initCanvas.removeEventListener("click", draw);
    };
  }, [canvasId, draw, openStudentCertifyDrawer]);

  return {
    draw,
    verifyCode,
  };
}
